import styled from 'styled-components';

const BrowseTilePairTitle = styled.div`
  text-align: center;
  font-family: 'Avenir', 'Arial', sans-serif;
  font-size: 30px;
  font-weight: 900;
  letter-spacing: 1px;
  line-height: 41px;
  text-transform: uppercase;
`;

export default BrowseTilePairTitle;
